// components/filtv/filtvHelpers.js
//
// Client-side stand-in for the backend's location-based ad matching
// (Area > Pincode > City > State > India-default), per the FiLTV spec.
// Once the real scoring lives server-side, this becomes a thin pass-through.

export function selectAdForChannel(lcn, advertisements = [], location = {}) {
    const candidates = advertisements.filter((ad) => ad.lcn === lcn);
    if (!candidates.length) return null;

    const scored = candidates.map((ad) => {
        let score = 10; // India-wide default

        if (location.state && ad.state === location.state) {
            score = Math.max(score, 30);
        }
        if (location.city && ad.city === location.city) {
            score = Math.max(score, 50);
        }
        if (location.pincode && ad.pincode === location.pincode) {
            score = Math.max(score, 70);
        }
        if (location.area && ad.area === location.area) {
            score = Math.max(score, 100);
        }

        return { ad, score };
    });

    scored.sort((a, b) => b.score - a.score);
    return scored[0].ad;
}

export function buildChannelAvailability(channels = [], advertisements = []) {
    const lcnsWithAds = new Set(advertisements.map((ad) => ad.lcn));

    return channels.map((channel) => ({
        ...channel,
        hasAd: lcnsWithAds.has(channel.lcn),
    }));
}
